import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const DeleteInvoiceDialog = ({
  open,
  fileName,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  fileName: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('Delete invoice', 'Ta bort faktura')}
          </DialogTitle>

          <DialogDescription className="mt-2">
            {t(
              'Delete "{name}"? This permanently removes the file from your invoices.',
              'Ta bort "{name}"? Detta tar bort filen permanent från dina fakturor.'
            ).replaceAll('{name}', fileName)}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            {t('Cancel', 'Avbryt')}
          </Button>

          <Button variant="destructive" onClick={onConfirm}>
            {t('Delete', 'Ta bort')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
